<template>
  <div class="imexport-dialog">
    <el-dropdown class="imexport-button" @command="handleExportImport">
      <el-button class="dropdown-button">
        <i class="fa fa-cog fa-lg"></i>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="export" v-show="exportUrl">エクスポート</el-dropdown-item>
        <el-dropdown-item command="import" v-show="importUrl">インポート</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog title="エクスポート" :visible.sync="exportDialog.visible" :close-on-click-modal="false" align="left">
      <span>{{ title }}のデータをエクスポートします。</span>
      <el-form :model="exportForm" ref="exportForm" :rules="exportFormRules">
        <el-form-item label="メールアドレス" prop="email">
          <el-input type="text" v-model="exportForm.email" autocomplete="on"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-alert v-if="exportDialog.isAlert" :title="exportDialog.errorMessage" type="error" show-icon :closable="false"></el-alert>
        <el-alert v-if="exportDialog.isInfo" :title="exportDialog.message" type="info" show-icon :closable="false"></el-alert>
        <el-button @click="handleExport(1)" :loading="exportDialog.testLoading">テストメール送信</el-button>
        <el-button type="primary" @click="handleExport(0)" :loading="exportDialog.loading">メール送信（エクスポート）</el-button>
        <el-button @click="exportDialog.visible = false">閉じる</el-button>
      </span>
    </el-dialog>

    <el-dialog title="インポート" :visible.sync="importDialog.visible" :close-on-click-modal="false" align="left">
      <span>{{ title }}のデータをインポートします。</span>
      <div class="note">
        <span class="box-title">注意</span>
        <p v-if="isCatalog">現在有効化している状態はすべて無効化された状態になり、CSVファイルに書かれたデータで有効化されます。CSVファイルに書かれていないデータは無効化されます。</p>
        <p v-else>CSVファイルに書かれたデータで置換され、CSVファイルに書かれていないデータは削除されます。</p>
      </div>
      <el-upload
        ref="upload"
        :action="importUrl"
        :auto-upload="false"
        :limit="1"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeUpload"
        :headers="xsrfHeaders"
      >
        <el-button slot="trigger" size="small" type="primary">ファイルの選択</el-button>
        <div class="el-upload__tip" slot="tip">インポートするcsvファイルを選択してください。</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-alert v-if="importDialog.errorMessage" :title="importDialog.errorMessage" type="error" show-icon :closable="false"></el-alert>
        <el-button type="success" @click="submitUpload" :loading="importDialog.loading">インポート</el-button>
        <el-button @click="importDialog.visible = false">閉じる</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "ImExport",
  props: {
    title: String,
    exportUrl: String,
    importUrl: String,
    isCatalog: {
      type: Boolean,
      default: false
    },
    fetch: Function
  },
  data () {
    return {
      exportDialog: {
        visible: false,
        testLoading: false,
        loading: false,
        isAlert: false,
        isInfo: false,
        message: '',
        errorMessage: ''
      },
      importDialog: {
        visible: false,
        loading: false,
        errorMessage: ''
      },
      exportForm: {
        email: '',
      },
      exportFormRules: {
        email: [
          { required: true, message: 'メールアドレスは必ず入力してください。' },
          { type: 'email', message: 'メール形式で入力してください。' }
        ],
      }
    }
  },
  computed: {
    xsrfHeaders: function() {
      for (let c of document.cookie.split('; ')) {
        if (c.startsWith('csrftoken=')) {
          return {'X-CSRFToken': c.slice(10)};
        }
      }
      return {};
    }
  },
  methods: {
    handleExportImport(command) {
      if (command === 'export') {
          this.onClickExportButton()
      } else if (command === 'import') {
          this.onClickImportButton()
      }
    },
    onClickExportButton () {
      this.exportDialog = Object.assign({}, this.exportDialog, {
        loading: false,
        isAlert: false,
        isInfo: false,
        errorMessage: '',
        visible: true
      })
    },
    onClickImportButton () {
      this.importDialog = Object.assign({}, this.importDialog, {
        visible: true,
        loading: false,
        errorMessage: ''
      })
    },
    handleExport (test) {
      let ref = this.$refs['exportForm']
      ref.validate((valid) => {
        if (valid) {
          if (test) {
            this.exportDialog.testLoading = true
          } else {
            this.exportDialog.loading = true
          }
          axios.post(this.exportUrl, {
            test: test,
            email: this.exportForm.email
          }).then((response) => {
            if (response.data.message !== undefined) {
              console.log(response)
              this.exportDialog.isInfo = true
              this.exportDialog.message = response.data.message
            }
          }).catch((error) => {
            if (error.response !== undefined) {
              this.exportDialog.isAlert = true
              this.exportDialog.loading = false
              if (error.response.status === 400) {
                let e = error.response.data
                console.log(e)
                if (Array.isArray(e)) {
                  this.exportDialog.errorMessage = e.join(',')
                } else {
                  if ('error' in e) {
                    this.exportDialog.errorMessage = e.error
                  } else if ('detail' in e) {
                    this.exportDialog.errorMessage = e.detail
                  } else {
                    this.exportDialog.errorMessage = e
                  }
                }
              } else {
                let e = error.response.data
                if (e.hasOwnProperty('detail')) {
                  this.exportDialog.errorMessage = e.detail
                } else {
                  this.exportDialog.errorMessage = '不明なエラーが発生しました。'
                }
              }
            }
          })
          this.exportDialog.testLoading = false
          this.exportDialog.loading = false
        }
      })
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    handleUploadSuccess(res, file) {
      this.$refs.upload.clearFiles()
      this.importDialog.visible = false
      this.importDialog.loading = false
      this.$notify({
        title: '成功',
        message: 'インポートに成功しました',
        type: 'success',
        duration: 2000
      })
      this.fetch()
    },
    handleUploadError(err, res, file) {
      this.importDialog.errorMessage = err.message
      this.importDialog.loading = false
    },
    beforeUpload(file) {
      const isCSV = file.name.endsWith(".csv")
      if (!isCSV) {
        this.$message.error("CSVファイルを選択してください。")
      } else {
        this.importDialog.loading = true
      }
      const ret = isCSV
      return ret
    },
  }
};
</script>

<style scoped>
.el-button {
  padding: 12px 20px;
}
.note {
    position: relative;
    margin: 2em 0;
    padding: 0.5em 1em;
    border: solid 3px #f56c6c;
    border-radius: 8px;
}
.note .box-title {
    position: absolute;
    display: inline-block;
    top: -10px;
    left: 10px;
    padding: 0 9px;
    line-height: 1;
    font-size: 17px;
    background: #FFF;
    color: #f56c6c;
    font-weight: bold;
}
.note p {
    margin: 0; 
    padding: 0;
}
</style>